import bridge from '@vkontakte/vk-bridge';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import { creditsImage } from './img/OnBoarding/credits';
import { createEventImage } from './img/OnBoarding/createEvent';
import { createPaymentImage } from './img/OnBoarding/createPayment';
import { inviteFriendsImage } from './img/OnBoarding/inviteFriends';
import { profileImage } from './img/OnBoarding/profile';
import { notifyImage } from './img/OnBoarding/notify';
import { Panels } from './panels/Consts';
import { parseQueryString } from './helpers/helpers';
import { Modals, VK_RETARGETING_CODE } from './Consts';
import { getRouteEventsList, getRouteProfile } from './route';

export const VkBridge = {
  notifications_status: false,
  bridge: bridge,
  getInitData: (openData, version) => {
    return {
      ...openData,
      version,
      lang: openData.vk_language,
    }
  },
  init: (context, appOpenParams) => {
    VkBridge.notifications.set(appOpenParams?.vk_are_notifications_enabled == 1);

    VkBridge.bridge.subscribe(({ detail: { type, data } }) => {
      if (type === 'VKWebAppUpdateConfig') {
        const schemeAttribute = document.createAttribute('scheme');
        schemeAttribute.value = data.appearance || data.scheme || 'light';
        document.body.attributes.setNamedItem(schemeAttribute);

        context.setColorScheme(data.appearance || data.scheme || 'light');
      } else if (type === 'VKWebAppGetUserInfoResult') {

      } else if (type === 'VKWebAppDenyNotificationsResult') {
        VkBridge.notifications.set(data.result);
      }
    });

    VkBridge.bridge.send('VKWebAppInit', {});
    VkBridge.bridge.send('VKWebAppGetUserInfo', {});
  },
  copyToClipboard: (text, callback = null) => {
    VkBridge.bridge.send('VKWebAppCopyText', {text})
      .then(() => {
        if (callback) {
          callback(text);
        } else {
          VkBridge.hapticFeedback.success();
        }
      })
      .catch((error) => {
        VkBridge.hapticFeedback.error();
      });
  },
  hapticFeedback: {
    success: () => VkBridge.bridge.send('VKWebAppTapticNotificationOccurred', {type: 'success'}).then(() => {}).catch(() => {}),
    error: () => VkBridge.bridge.send('VKWebAppTapticNotificationOccurred', {type: 'error'}).then(() => {}).catch(() => {}),
  },
  checkQrCodeScan: () => {
    if (process.env.NODE_ENV === 'development') {
      return true;
    }

    return bridge.supports('VKWebAppOpenCodeReader')
  },
  scanQrCode: (callback, context) => {
    if (!VkBridge.bridge.supports('VKWebAppOpenCodeReader') && process.env.NODE_ENV === 'development') {
      callback({code_data: 't=20230225T1736&s=1398.87&fn=9960440503239363&i=24388&fp=1243116865&n=1'});
      return;
    }

    VkBridge.bridge.send('VKWebAppOpenCodeReader')
      .then((data) => {
        callback(data);
      })
      .catch((error) => {
        if (error?.error_data?.error_code === 4) {
          VkBridge.bridge.send('VKWebAppTapticNotificationOccurred', {type: 'error'});
          return;
        }

        context.showError(error);
      });
  },
  runOnBoarding: (context) => {
    VkBridge.bridge.send('VKWebAppShowSlidesSheet', {
        slides: [
          {
            media: {
              type: 'image',
              blob: creditsImage,
            },
            title: context.lang().getKey('OnBoarding', 'slide_about_title'),
            subtitle: context.lang().getKey('OnBoarding', 'slide_about_text'),
          },
          {
            media: {
              type: 'image',
              blob: createEventImage,
            },
            title: context.lang().getKey('OnBoarding', 'slide_credits_title'),
            subtitle: context.lang().getKey('OnBoarding', 'slide_credits_text'),
          },
          {
            media: {
              type: 'blob',
              blob: createPaymentImage,
            },
            title: context.lang().getKey('OnBoarding', 'slide_create_payment_title'),
            subtitle: context.lang().getKey('OnBoarding', 'slide_create_payment_text'),
          },
          {
            media: {
              type: 'image',
              blob: inviteFriendsImage,
            },
            title: context.lang().getKey('OnBoarding', 'slide_friends_title'),
            subtitle: context.lang().getKey('OnBoarding', 'slide_friends_text'),
          },
          {
            media: {
              type: 'image',
              blob: profileImage,
            },
            title: context.lang().getKey('OnBoarding', 'slide_profile_title'),
            subtitle: context.lang().getKey('OnBoarding', 'slide_profile_text'),
          },
          {
            media: {
              type: 'image',
              blob: notifyImage,
            },
            title: context.lang().getKey('OnBoarding', 'slide_notify_title'),
            subtitle: context.lang().getKey('OnBoarding', 'slide_notify_text'),
          },
        ]})
      .then((data) => {
        context.httpClient().passedOnBoarding();
        context.store.setPassedOnBoarding(true);
        VkBridge.bridge.retargeting.OnBoardingFinish(context.store.currentUserId, data.action);
      })
      .catch((error) => {});
  },
  retargeting: {
    metrica_code: window.metrica_code,
    init: (userId) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      VkBridge.bridge.send('VKWebAppTrackEvent', {
        event_name: 'visit_website',
        user_id: userId,
      }).catch(() => {});

      window.ym(VkBridge.retargeting.metrica_code, 'userParams', {UserID: userId});
      window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'init');
    },
    onBoardingFinish: (userId, action) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      VkBridge.bridge.send('VKWebAppTrackEvent', {
        event_name: 'take_test',
        user_id: userId,
      }).catch(() => {});
      window.ym(VkBridge.retargeting.metrica_code, 'userParams', {UserID: userId});

      if (action === 'confirm') {
        window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'onBoardingFinishConfirm');
      } else if (action === 'reject') {
        window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'onBoardingFinishReject');
      } else {
        window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'onBoardingFinishCancel');
      }
    },
    addPaymentInfo: (userId) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      VkBridge.bridge.send('VKWebAppTrackEvent', {
        event_name: 'registration',
        user_id: userId,
      }).catch(() => {});

      window.ym(VkBridge.retargeting.metrica_code, 'userParams', {UserID: userId});
      window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'add_payment_info');
    },
    createEvent: (userId) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      VkBridge.bridge.send('VKWebAppTrackEvent', {
        event_name: 'create_event',
        user_id: userId,
      }).catch(() => {});

      window.ym(VkBridge.retargeting.metrica_code, 'userParams', {UserID: userId});
      window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'create_event');
    },
    createPayment: (userId) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      VkBridge.bridge.send('VKWebAppTrackEvent', {
        event_name: 'create_payment',
        user_id: userId,
      }).catch(() => {});

      window.ym(VkBridge.retargeting.metrica_code, 'userParams', {UserID: userId});
      window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'create_payment');
    },
    createRepayment: (userId) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      VkBridge.bridge.send('VKWebAppTrackEvent', {
        event_name: 'create_repayment',
        user_id: userId,
      }).catch(() => {});

      window.ym(VkBridge.retargeting.metrica_code, 'userParams', {UserID: userId});
      window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'create_repayment');
    },
    openInvite: (userId) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      VkBridge.bridge.send('VKWebAppTrackEvent', {
        event_name: 'open_invite',
        user_id: userId,
      }).catch(() => {});

      window.ym(VkBridge.retargeting.metrica_code, 'userParams', {UserID: userId});
      window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'open_invite');
    },
    copyInvite: (userId) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      VkBridge.bridge.send('VKWebAppTrackEvent', {
        event_name: 'copy_invite',
        user_id: userId,
      }).catch(() => {});

      window.ym(VkBridge.retargeting.metrica_code, 'userParams', {UserID: userId});
      window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'copy_invite');
    }
  },
  shareInvite: (eventId, invite, inviteLink, context) => {
    //share
    if (context.store.addToChatEnabled) {
      VkBridge.bridge.send('VKWebAppAddToChat', {
        action_title: context.lang().getKey('app', 'add_to_chat_title'),
        hash: '/invite/' + invite,
      })
      .then(() => {})
      .catch((e) => {
        if (e?.error_data?.error_code !== 4) {
          //Если ошибка добавления в чат - делаем шэр
          VkBridge.bridge.send('VKWebAppShare', {'link': inviteLink})
            .then(() => {})
            .catch(() => {});
        }
      });
    } else {
      VkBridge.bridge.send('VKWebAppShare', {'link': inviteLink})
        .then((e) => {})
        .catch(() => {});
    }

    VkBridge.retargeting.copyInvite(context.store.currentUserId);
  },
  copyInvite: (invite, context, callback) => {
    //copy to clipboard
    VkBridge.copyToClipboard(invite, () => callback(context.lang().getKey(Panels.EVENT_INFO, 'invite_copy_success')));
    VkBridge.retargeting.copyInvite(context.store.currentUserId);
  },
  notifications: {
    toggle: (value, callback = () => {}) => {
      if (value) {
        VkBridge.bridge.send('VKWebAppAllowNotifications')
          .then((data) => {
            VkBridge.notifications.set(data.result);
            callback(data.result);
          })
          .catch(() => {
            VkBridge.notifications.set(false);
            callback(false);
          });
      } else {
        VkBridge.notifications.set(false);
        callback(false);
      }
    },
    get: () => VkBridge.notifications_status,
    set: (value) => {
      VkBridge.notifications_status = value;
    },
  }
}

export const TelegramBridge = {
  bridge: window?.Telegram?.WebApp || {},
  getInitData: (openData, version) => {
    if (process.env.NODE_ENV === 'development') {
      const initDataUnsafe = parseQueryString(openData.tgWebAppData || '', '');
      initDataUnsafe.user = JSON.parse(initDataUnsafe.user || '{}');

      return {
        ...initDataUnsafe,
        version
      };
    }

    return {
      ...TelegramBridge?.bridge?.initDataUnsafe || {},
      version,
      lang: JSON.parse(parseQueryString(openData.tgWebAppData || '', '').user || '{}').language_code,
    };
  },
  init: (context, appOpenParams) => {
    TelegramBridge.bridge.ready();
    TelegramBridge.bridge.expand();
    if (TelegramBridge.bridge.version >= 6.2) {
      TelegramBridge.bridge.enableClosingConfirmation();
    }
    if (TelegramBridge.bridge.version >= 6.1) {
      TelegramBridge.bridge.BackButton.onClick(() => {
        if (context.router.getHistory().length < 2) {
          context.router.replace(...getRouteEventsList());
        } else {
          context.router.back();
        }
      });
    }
    if (TelegramBridge.bridge.version >= 7.0) {
      TelegramBridge.bridge.SettingsButton.onClick(() => context.router.push(...getRouteProfile()));
      TelegramBridge.bridge.SettingsButton.show();
    }
    if (TelegramBridge.bridge.version >= 7.7) {
      TelegramBridge.bridge.disableVerticalSwipes();
    }
  },
  copyToClipboard: (text, callback = null) => {
    if (copy(text)) {
      if (callback) {
        callback(text);
      } else {
        TelegramBridge.hapticFeedback.success();
      }
    } else {
      TelegramBridge.hapticFeedback.error();
    }
  },
  hapticFeedback: {
    success: () => TelegramBridge.bridge.HapticFeedback.notificationOccurred('success'),
    error: () => TelegramBridge.bridge.HapticFeedback.notificationOccurred('error'),
  },
  checkQrCodeScan: () => {
    return TelegramBridge.bridge.version >= 6.4;
  },
  scanQrCode: (callback, context) => {
    if (process.env.NODE_ENV === 'development') {
      callback({code_data: 't=20230225T1736&s=1398.87&fn=9960440503239363&i=24388&fp=1243116865&n=1'});
      return;
    }

    TelegramBridge.bridge.showScanQrPopup({}, (data) => {
      TelegramBridge.bridge.closeScanQrPopup();
      callback({code_data: data});
    });
  },
  runOnBoarding: (context) => {
    context.router.showModal(Modals.ON_BOARDING_MODAL);
  },
  retargeting: {
    metrica_code: window.metrica_code,
    init: (userId) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      window.ym(VkBridge.retargeting.metrica_code, 'userParams', { UserID: userId });
      window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'init');
    },
    onBoardingFinish: (userId, action) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      window.ym(VkBridge.retargeting.metrica_code, 'userParams', {UserID: userId});

      if (action === 'confirm') {
        window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'onBoardingFinishConfirm');
      } else if (action === 'reject') {
        window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'onBoardingFinishReject');
      } else {
        window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'onBoardingFinishCancel');
      }
    },
    addPaymentInfo: (userId) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      window.ym(VkBridge.retargeting.metrica_code, 'userParams', {UserID: userId});
      window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'add_payment_info');
    },
    createEvent: (userId) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      window.ym(VkBridge.retargeting.metrica_code, 'userParams', {UserID: userId});
      window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'create_event');
    },
    createPayment: (userId) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      window.ym(VkBridge.retargeting.metrica_code, 'userParams', {UserID: userId});
      window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'create_payment');
    },
    createRepayment: (userId) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      window.ym(VkBridge.retargeting.metrica_code, 'userParams', {UserID: userId});
      window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'create_repayment');
    },
    openInvite: (userId) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      window.ym(VkBridge.retargeting.metrica_code, 'userParams', {UserID: userId});
      window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'open_invite');
    },
    copyInvite: (userId) => {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      window.ym(VkBridge.retargeting.metrica_code, 'userParams', {UserID: userId});
      window.ym(VkBridge.retargeting.metrica_code, 'reachGoal', 'copy_invite');
    }
  },
  shareInvite: (eventId, invite, inviteLink, context) => {
    //share
    TelegramBridge.retargeting.copyInvite(context.store.currentUserId);

    context.spinner(true);
    context.httpClient()
      .sendInviteMessage(eventId)
      .then(() => {
        context.spinner(false);
        TelegramBridge.bridge.showAlert(context.lang().getKey(Panels.EVENT_INFO, 'send_invite_success'));
      })
      .catch((error) => {
        context.showError(error);
        console.error(error);
      });
  },
  copyInvite: (invite, context, callback) => {
    //copy to clipboard
    TelegramBridge.copyToClipboard(invite, () => {
      TelegramBridge.bridge.showPopup({
        message: context.lang().getKey(Panels.EVENT_SETTINGS, 'invite_copy_to_clipboard'),
      });

      TelegramBridge.bridge.HapticFeedback.notificationOccurred('success');
    });
    TelegramBridge.retargeting.copyInvite(context.store.currentUserId);
  },
  notifications: {
    toggle: (value) => {},
    get: () => true,
    set: (value) => {},
  },
}

const retargeting = PropTypes.shape({
  init: PropTypes.func.isRequired,
  onBoardingFinish: PropTypes.func.isRequired,
  addPaymentInfo: PropTypes.func.isRequired,
  createEvent: PropTypes.func.isRequired,
  createPayment: PropTypes.func.isRequired,
  createRepayment: PropTypes.func.isRequired,
  openInvite: PropTypes.func.isRequired,
  copyInvite: PropTypes.func.isRequired,
});

export const BridgeType = PropTypes.shape({
  init: PropTypes.func.isRequired,
  copyToClipboard: PropTypes.func.isRequired,
  checkQrCodeScan: PropTypes.func.isRequired,
  scanQrCode: PropTypes.func.isRequired,
  runOnBoarding: PropTypes.func.isRequired,
  retargeting: retargeting,
});

VkBridge.propTypes = BridgeType;
TelegramBridge.propTypes = BridgeType;